var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconActiveFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.00004 14.6654C11.6819 14.6654 14.6667 11.6806 14.6667 7.9987C14.6667 4.3168 11.6819 1.33203 8.00004 1.33203C4.31814 1.33203 1.33337 4.3168 1.33337 7.9987C1.33337 11.6806 4.31814 14.6654 8.00004 14.6654Z",
    fill: "#FDBE44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05334 10.3877C6.92 10.3877 6.79334 10.3344 6.7 10.241L4.81333 8.35437C4.62 8.16104 4.62 7.84104 4.81333 7.64771C5.00667 7.45438 5.32667 7.45438 5.52 7.64771L7.05334 9.18104L10.48 5.75438C10.6733 5.56104 10.9933 5.56104 11.1867 5.75438C11.38 5.94771 11.38 6.26771 11.1867 6.46104L7.40667 10.241C7.31334 10.3344 7.18667 10.3877 7.05334 10.3877Z",
    fill: "#FDBE44"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconActiveFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-active-filter.083d5c0578a510de07d8bc2393b43ad6.svg";